import { Injectable } from '@angular/core';
import { Options } from 'highcharts/highstock';
import { cloneDeep } from 'lodash';
import { BehaviorSubject } from 'rxjs';

import { DEFAULT_HIGHSTOCK_CONFIG } from '../models/highstock-config';

/** A service to update the mouse mode */
@Injectable({ providedIn: 'root' })
export class HighchartsConfigService {
    configMap: Map<string, BehaviorSubject<Options>> = new Map();

    /** add a new entry to the map for a new plot. Initialize with default config */
    initPlotConfig( plotId: string ) {
        // we need to clone the default config, otherwise plots will share memory and things will get weird
        this.configMap.set( plotId, new BehaviorSubject( cloneDeep( DEFAULT_HIGHSTOCK_CONFIG ) ));
    }

    /** replace a plot's current config with an updated one */
    setPlotConfig( plotId: string, options: Options ) {
        this.configMap.get( plotId ).next( options );
    }

    /** return a plot's config */
    getPlotConfig( plotId: string ) {
        return this.configMap.get( plotId ).getValue();
    }

    /** return an observable that emits when its config is updated */
    getPlotConfig$( plotId: string ) {
        return this.configMap.get( plotId );
    }
}
